import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-modal-main" }
const _hoisted_2 = { class: "p-modal-main__scrollable" }
const _hoisted_3 = { class: "p-modal-main__scrollable__padding" }
const _hoisted_4 = {
  key: 0,
  class: "p-modal-main__head"
}
const _hoisted_5 = { class: "p-modal-main__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-modal-main__base" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.body)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "p-modal-main__content",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.$slots.head)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "head", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "body", {}, undefined, true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots.fullBody)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "p-modal-main__full_body",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _renderSlot(_ctx.$slots, "fullBody", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}